import { Box, CircularProgress, Stack } from '@mui/material';

export const Loading = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Stack sx={{ color: 'grey.500' }} spacing={2} direction='row'>
                <CircularProgress sx={{ color: '#6565f5' }} />
            </Stack>
        </Box>
    )
}
